import { CombinedError } from '@/graphql';
import { AppError } from './AppError';

/**
 * Error thrown when we tried to look something up in the API, but it was
 * not found (i.e. returns null). Optionally provide the slug that was used
 * to do the lookup.
 */
export class NotFoundError extends AppError {
  constructor(entityType: string, slug?: string) {
    super({
      title: `We can't find that ${entityType}`,
      message: `The ${entityType}${slug === undefined ? '' : ` ${slug}`} might not exist anymore,
        or there's a typo in the URL. Contact the owner for more information.
      `,
    });
    Object.setPrototypeOf(this, NotFoundError.prototype);
  }
}

export function isNotFoundError(error: Error) {
  return (
    error instanceof NotFoundError ||
    (error instanceof CombinedError && error.message.match(/\[GraphQL\] Resource.*not found/))
  );
}
